import React, { useEffect } from "react";
import { Script } from "gatsby";

export default function HubspotForm() {
  useEffect(() => {
    initializeHubspotForm();
  }, []);

  function initializeHubspotForm() {
    if ("hbspt" in window) {
      window.hbspt.forms.create({
        region: "na1",
        portalId: "21246831",
        formId: "ec37ea90-3981-4f99-8f5e-42d446cd5604", // Update this if needed
        target: "#hubspotForm",
      });
    } else {
      setTimeout(initializeHubspotForm, 500);
    }
  }

  return (
    <>
      <Script
        charset="utf-8"
        type="text/javascript"
        src="//js.hsforms.net/forms/shell.js"
      />
      <div
        id="hubspotForm"
        className="hubspot-container my-12 font-medium"
      />
    </>
  );
}
